import { addLocaleData } from 'react-intl';
import { setCookie } from 'ks-client-admin/utils/cookie';

import dataEnglish from 'react-intl/locale-data/en';
import dataMalaysian from 'react-intl/locale-data/ms';
import dataIndonesia from 'react-intl/locale-data/id';
import dataVietnamese from 'react-intl/locale-data/vi';
import dataJapanese from 'react-intl/locale-data/ja';
import dataChinese from 'react-intl/locale-data/zh';
import dataSpanish from 'react-intl/locale-data/es';
import dataKorean from 'react-intl/locale-data/ko';
import dataFrench from 'react-intl/locale-data/fr';
import dataGerman from 'react-intl/locale-data/de';
import dataItalian from 'react-intl/locale-data/it';

export const defaultLocale = 'en';

export function initLocales() {
  addLocaleData(dataEnglish);
  addLocaleData(dataChinese);
  addLocaleData(dataIndonesia);
  addLocaleData(dataJapanese);
  addLocaleData(dataSpanish);
  addLocaleData(dataKorean);
  addLocaleData(dataMalaysian);
  addLocaleData(dataVietnamese);
  addLocaleData(dataFrench);
  addLocaleData(dataItalian);
  addLocaleData(dataGerman);
}

export function storeUserLocale(user) {
  const locale = getUserLocale(user);
  setCookie('locale', locale);
}

export function getUserLocale(user) {
  let locale = defaultLocale;

  if (user && user.preferred_language && user.preferred_language.cid) {
    locale = user.preferred_language.cid.replace('dt:language:', '');
  }

  return locale;
}
